import axios from '../api/axios';

const ReportService = {
    getSalesReport: (startDate, endDate) => {
        return axios.get(`/report/sales?startDate=${startDate}&endDate=${endDate}`);
    },
    getExpenseReport: (startDate, endDate) => {
        return axios.get(`/report/expenses?startDate=${startDate}&endDate=${endDate}`);
    },
    getProfitLossReport: (startDate, endDate) => {
        return axios.get(`/report/profit-loss?startDate=${startDate}&endDate=${endDate}`);
    },
    getStockReport: () => {
        return axios.get('/report/stock');
    },
    getCriticalStockReport: () => {
        return axios.get('/report/critical-stock');
    },
    getCustomerBalanceReport: () => {
        return axios.get('/report/customer-balance');
    },
    getBranchReport: (startDate, endDate) => {
        return axios.get(`/report/branch?startDate=${startDate}&endDate=${endDate}`);
    },
    getAccountTransactionsReport: (startDate, endDate, accountTypes = [], accountIds = []) => {
        const typesParam = accountTypes.length > 0 ? `&accountTypes=${accountTypes.join(',')}` : '';
        const idsParam = accountIds.length > 0 ? `&accountIds=${accountIds.join(',')}` : '';
        return axios.get(`/report/account-transactions?startDate=${startDate}&endDate=${endDate}${typesParam}${idsParam}`);
    }
};

export default ReportService;
